import * as ents from '@attain-apps/entities'
import * as graphql from '@attain-apps/fe/web/main/lib/graphql'
import * as transformers from '@attain-apps/transformers'
import gql from 'graphql-tag'

import * as common from '../../../../../../../common'

const DOC = gql`
  ${common.gql.dms.data.fragments.variable.DOC}
  query MosaicPageRenderingWidget(
    $widgetIdentifier: FlexibleIdentifierInput!
    $appPageId: ID!
    $scenarioId: ID!
    $appId: ID!
    $zoneId: ID!
    $tenantId: ID!
    $variableOverrides: [VariableValueInput!]
  ) {
    tenant(id: $tenantId) {
      zone(id: $zoneId) {
        app(id: $appId) {
          scenario(id: $scenarioId) {
            mosaicPageRendering(
              appPageId: $appPageId
              variableOverrides: $variableOverrides
            ) {
              widget(
                identifier: $widgetIdentifier
                variableOverrides: $variableOverrides
              ) {
                id
                payload
                alias
                variables {
                  ...FragmentVariable
                }
              }
            }
          }
        }
      }
    }
  }
`

const TRANSFORMER = graphql.transformers.OUT.select<
  graphql.schema.MosaicPageRenderingWidgetQuery,
  ents.core.mosaic.Widget.Rendering,
  'tenant'
>(
  'tenant',
  graphql.transformers.OUT.select(
    'zone',
    graphql.transformers.OUT.select(
      'app',
      graphql.transformers.OUT.select(
        'scenario',
        graphql.transformers.OUT.select(
          'mosaicPageRendering',
          graphql.transformers.OUT.select(
            'widget',
            graphql.transformers.OUT.object({
              // NOTE: Eslint disable turned on because of eslint error for payload argument
              // that is type of any
              /* eslint-disable @typescript-eslint/no-unsafe-argument */
              alias: graphql.transformers.OUT.validate(
                transformers.PASS_THROUGH,
                ents.core.common.Aliased.isAliased,
                { warnOnly: true },
              ),
              content: ({ payload }) => JSON.parse(payload).content,
              id: graphql.transformers.OUT.validate(
                transformers.PASS_THROUGH,
                ents.core.mosaic.Widget.Id.assertIsId,
                { warnOnly: true },
              ),
              name: ({ payload }) => JSON.parse(payload).name,
              onClick: ({ payload }) => JSON.parse(payload).onClick,
              overflowActions: ({ payload }) =>
                JSON.parse(payload).overflowActions,
              type: ({ payload }) => JSON.parse(payload).type,
              variables: {
                usingFullInput: graphql.transformers.OUT.default(
                  graphql.transformers.OUT.select(
                    'variables',
                    graphql.transformers.OUT.list(
                      common.gql.dms.data.fragments.variable.TRANSFORMER,
                      { onNullish: 'remove' },
                    ),
                  ),
                  [],
                ),
              },
              watch: ({ payload }) => JSON.parse(payload).watch,
              /* eslint-enable @typescript-eslint/no-unsafe-argument */
            }),
          ),
        ),
      ),
    ),
  ),
)

export const executor = graphql.createExecutor<
  graphql.schema.MosaicPageRenderingWidgetQuery,
  ents.core.mosaic.Widget.Rendering | undefined,
  graphql.schema.MosaicPageRenderingWidgetQueryVariables
>({
  query: DOC,
  transformer: TRANSFORMER,
})
